import { useState } from "react";
import ResourceList from "../resources/ResourceList";
import { resourcesConfig } from "../resources/resourcesConfig";
import CrearMedicoModal from "./CrearMedicoModal";

const Medicos = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    // Necesitamos un key para forzar la recarga del ResourceList
    const [refreshKey, setRefreshKey] = useState(0);

    const handleSuccess = () => {
        setRefreshKey((prev) => prev + 1);
    };

    return (
        <>
            <ResourceList
                key={refreshKey}
                {...resourcesConfig.medicos}
                secondaryActionLabel="+ Crear Médico"
                onSecondaryAction={() => setIsModalOpen(true)}
            />

            {isModalOpen && (
                <CrearMedicoModal
                    onClose={() => setIsModalOpen(false)}
                    onSuccess={handleSuccess}
                />
            )}
        </>
    );
};

export default Medicos;